export const HeaderLoading = () => {
  return (
    <div className="bg-white-100 dark:bg-black-800 xxs:p-6 rounded-md shadow-md lg:pb-28">
      <div className="flex space-x-6">
        <div className="xxs:w-22 lg:w-48 flex justify-center items-center clip-mizar-hexagon">
          <div className="xxs:h-16 xxs:w-16 lg:h-32 lg:w-32 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
        </div>
        <div className="w-full md:w-2/5 2xl:w-3/5 items-center ">
          <div className="h-3 w-48 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
          <div className="h-2 w-28 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse xxs:mt-2" />
          <div className="space-y-2 xxs:mt-8">
            <div className="h-2 w-28 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
            <div className="h-2 w-28 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
};
